import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";

export default function NotFound() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-14 sm:py-24 text-center" data-testid="not-found-page">
      <Seo title="Page not found" noindex />
      <p className="eyebrow">404</p>
      <h1 className="mt-3 text-4xl sm:text-5xl font-bold text-[#0B2150]">We couldn't find that page</h1>
      <p className="mt-4 text-slate-600">The community or page may have moved. Try searching the directory.</p>
      <Link to="/search" className="mt-8 inline-flex rounded-full bg-[#0B2150] text-white px-6 py-3 font-semibold hover:bg-[#03A896]" data-testid="not-found-search-link">Search HOAs</Link>
    </div>
  );
}
